<script lang="ts" setup>
import './FormKitCustomUserSwitchClientCompany.scss'
const clientModel = ref<boolean>(true)
const companyModel = ref<boolean>(false)
</script>
<template>
  <div class="row formkit-custom-user-switch-client-company-wrapper">
    <div class="col-12 col-md-6">
      <FormKit
        v-model="clientModel"
        validation="required"
        type="radio"
        :label="$t('typ klienta')"
        name="IsClient"
        :options="[
          {
            label: 'Som klient',
            value: true,
          },
          {
            label: 'Nie som klient',
            value: false,
          },
        ]"
      />
    </div>
    <div class="col-12 col-md-6">
      <FormKit
        v-model="companyModel"
        validation="required"
        type="radio"
        :label="$t('typ účtu')"
        name="IsCompany"
        :options="[
          {
            label: 'Fyzická osoba',
            value: false,
          },
          {
            label: 'Spoločnosť',
            value: true,
          },
        ]"
      />
    </div>
  </div>
  <div class="row">
    <div
      v-if="clientModel"
      class="col-12 col-md-6"
    >
      <FormKitCustomAgreementNumber />
    </div>
    <div
      v-if="clientModel && !companyModel"
      class="col-12 col-md-6"
    >
      <FormKitCustomBirthdate />
    </div>
    <div
      v-if="clientModel && companyModel"
      class="col-12 col-md-6"
    >
      <FormKit
        validation="required|number|length:8,8"
        name="ico"
        :label="$t('IČO')"
        :validation-messages="{
          required: $t('IČO je povinný údaj'),
          length: $t('IČO musí mať 8 číslic')
        }"
      />
    </div>
    <div
      v-if="!companyModel"
      class="col-12 col-md-6"
    >
      <FormKit
        validation="required"
        name="first_name"
        :label="$t('Meno')"
        :validation-messages="{
          required: $t('Meno je povinný údaj'),
        }"
      />
    </div>
    <div
      v-if="companyModel"
      class="col-12 col-md-6"
    >
      <FormKit
        validation="required"
        name="company_name"
        :label="$t('Názov spoločnosti')"
        :validation-messages="{
          required: $t('Názov spoločnosti je povinný údaj'),
        }"
      />
    </div>
    <div
      v-if="!companyModel"
      class="col-12 col-md-6"
    >
      <FormKit
        validation="required"
        name="last_name"
        :label="$t('Priezvisko')"
        :validation-messages="{
          required: $t('Priezvisko je povinný údaj'),
        }"
      />
    </div>
    <div
      v-if="companyModel"
      class="col-12 col-md-6"
    >
      <FormKit
        validation="required"
        name="person_name"
        :label="$t('Zastupujúca osoba')"
        :validation-messages="{
          required: $t('Zastupujúca osoba je povinný údaj'),
        }"
      />
    </div>
  </div>
</template>
